module.exports = __webpack_public_path__ + "img/xls.f847910f.svg";